module.exports = __webpack_public_path__ + "static/media/background.0c6db6fd.jpg";